import { RootState } from '../redux';

export const selectUploadHistoryState = (state: RootState) => state.uploadHistory;
